const patentCollect = [
  {
    path: '/patentCollect',
    name: 'patentCollect',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "patentCollect" */ '@/views/collect/patentCollect'),
    meta: {
      name: '知产交易 · 全网专利交易查询',
      breadCrumbName: '我的收藏'
    }
  },
];

export default patentCollect
